import styled from 'styled-components';

export const Container = styled.div`
	width: 332px;
	background-color: ${({ theme }) => theme.palette.secondary.white};
	border-radius: ${({ theme }) => theme.border.border_radius.br_lg};
	border: 1px solid ${({ theme }) => theme.palette.secondary[150]};
`;

export const Title = styled.h4`
	gap: 8px;
	margin: 0;
	width: 332px;
	height: 40px;
	padding: 16px;
	text-align: center;
	color: ${({ theme }) => theme.colors.text};
	font-size: ${({ theme }) => theme.sizes.fonts.fs_sm};
	font-weight: ${({ theme }) => theme.sizes.weights.semibold};
	line-height: ${({ theme }) => theme.sizes.line_heights.lh_xs};
	background-color: ${({ theme }) => theme.palette.secondary[100]};
	border: 1px solid ${({ theme }) => theme.palette.secondary[150]};
	letter-spacing: ${({ theme }) => theme.sizes.letter_spacings.ls_lg};
`;

export const BorgScaleTable = styled.table`
	width: 332px;
	border-collapse: collapse;
`;

export const TableCell = styled.td`
	padding: 10px 16px;
	color: ${({ theme }) => theme.colors.text};
	font-size: ${({ theme }) => theme.sizes.fonts.fs_sm};
	border: 1px solid ${({ theme }) => theme.palette.secondary[150]};

	&:first-child {
		text-align: center;
		font-weight: ${({ theme }) => theme.sizes.weights.semibold};
		width: 120px;
	}
`;

export const TableRow = styled.tr`
	&:hover {
		background-color: ${({ theme }) => theme.palette.secondary[50]};
	}

	&:last-child td {
		border-bottom: none;
	}
`;
